import { render, staticRenderFns } from "./createTipoClasse.vue?vue&type=template&id=07138e40&scoped=true"
import script from "./createTipoClasse.vue?vue&type=script&lang=js"
export * from "./createTipoClasse.vue?vue&type=script&lang=js"
import style0 from "./createTipoClasse.vue?vue&type=style&index=0&id=07138e40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07138e40",
  null
  
)

export default component.exports